import { useEffect, useState } from "react";

type VisitorLocale = {
  dateLabel: string;
  shortDate: string;
  city: string | null;
};

type IpApiResponse = { timezone?: string; city?: string };

export function useVisitorLocale(): VisitorLocale {
  const [state, setState] = useState<VisitorLocale>(() => buildLocale());

  useEffect(() => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    fetch("https://ipapi.co/json/", { signal: controller.signal })
      .then((r) => (r.ok ? (r.json() as Promise<IpApiResponse>) : Promise.reject()))
      .then((data) => setState(buildLocale(data.timezone, data.city ?? null)))
      .catch(() => undefined)
      .finally(() => clearTimeout(timeout));
    return () => {
      controller.abort();
      clearTimeout(timeout);
    };
  }, []);

  return state;
}

function buildLocale(timeZone?: string, city: string | null = null): VisitorLocale {
  return {
    dateLabel: capitalize(format({ weekday: "long", day: "numeric", month: "long" }, timeZone)),
    shortDate: format({ day: "numeric", month: "short" }, timeZone).replace(".", ""),
    city,
  };
}

function format(options: Intl.DateTimeFormatOptions, timeZone?: string) {
  try {
    return new Intl.DateTimeFormat("es-ES", { ...options, timeZone }).format(new Date());
  } catch {
    return new Intl.DateTimeFormat("es-ES", options).format(new Date());
  }
}

function capitalize(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
